export default __webpack_public_path__ + "b4ded1031f18bb6144a40cc25a66ea87.png";